import React, { Component } from 'react';
import ImageComponent from '../../CommonComponent/CommonImage';
import { withTranslation } from 'react-i18next';

const Symptoms = (props) => {

    const date = new Date(props.selectedDay.year, props.selectedDay.month, props.selectedDay.day);  // 2009-11-10
    const month = date.toLocaleString('default', { month: 'short' });

    return (
        <>
            {
                (props.selectedDay.symptoms !== null || props.selectedDay.moods !== null) &&
                <div className="experience-cont">
                    <div className="experience-cont-header">
                        <ImageComponent imageIcon={props.parentCompData.datePickerLogo.value.src} />
                        <h4>{props.selectedDay.day} {month}, {props.selectedDay.year}</h4>
                        
                    </div>
                    {props.selectedDay.resultMessage && <div className="experience-cont-pregnancy-chance">
                        <h2> {props.t('PeriodCalculator_ChanceOfPregnancyLabel')}</h2>
                    </div>}
                    {props.selectedDay.resultMessage && <div className="experience-cont-pregnancy-percentage">
                        <h2> {props.selectedDay.resultMessage}</h2>
                    </div>}

                    <p className="introheader">
                        {props.t('PeriodCalculator_SymptomsMoodsLabel')}
                    </p>
                    <div className="experience-cat">
                        {props.selectedDay.moods.map((item, index) => {
                            return (
                                <div key={item.Name}>
                                    <ImageComponent imageIcon={item.image.src} />
                                    <p className="exp-cat-header">{item.name}</p>
                                </div>
                            )
                        })}
                        {props.selectedDay.symptoms.map((item, index) => {
                            return (
                                <div >
                                    <ImageComponent imageIcon={item.image.src} />
                                    <p className="exp-cat-header">{item.name}</p>
                                </div>
                            )
                        })}

                    </div>
                </div>
            }
        </>
    )
}


export default withTranslation()(Symptoms)

